import currencyAllComponent from './currency.all.component';

export default angular
  .module('currency.all', [])
  .component('currencyall', currencyAllComponent)
  .name;



// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/currency/all/index.js